<template>
    <n-form
        v-show="!isFinished"
        className="form"
        ref="formRef"
        :model="formValue"
        :show-label="true"
        :rules="rules"
        size="medium">
        <n-form-item path="name" label="Имя">
            <n-input v-model:value="formValue.name" size="medium" placeholder="" />
        </n-form-item>
        <n-form-item path="phone" label="Телефон">
            <n-input-group>
                <n-input-group-label size="medium">+</n-input-group-label>
                <n-input v-model:value="formValue.phone" size="medium" placeholder="" />
            </n-input-group>
        </n-form-item>
        <n-form-item path="email" label="Почта">
            <n-input v-model:value="formValue.email" size="medium" placeholder="" />
        </n-form-item>
        <n-form-item path="city" label="Город">
            <n-input v-model:value="formValue.city" size="medium" placeholder="" />
        </n-form-item>
        <n-form-item path="agreementAccepted">
            <n-checkbox v-model:checked="formValue.agreementAccepted" size="medium">
                <n-text>
                    Даю согласие на
                    <n-text
                        type="primary"
                        @click="showPrivacyPolicy"
                        style="text-decoration: underline; cursor: pointer">
                        обработку персональных данных
                    </n-text>
                </n-text>
            </n-checkbox>
        </n-form-item>
        <n-button
            size="medium"
            block
            strong
            :loading="isLoading"
            :disabled="!formValue.agreementAccepted"
            type="primary"
            @click="handleSubmitButton">
            Зарегистрироваться
        </n-button>
    </n-form>
    <n-result
        size="medium"
        v-show="isFinished"
        status="success"
        title="Регистрация прошла успешно"
        description="На вашу почту отправлено сообщение с информацией для входа.">
        <template #footer>
            <div>Не приходит письмо? Проверьте папку «Спам»</div>
        </template>
    </n-result>

    <n-modal
        v-model:show="showPrivacyPolicyModal"
        preset="card"
        title="Согласие на обработку персональных данных"
        style="width: 700px">
        <n-scrollbar style="max-height: 500px">
            <n-space vertical :size="16">
                <n-text>
                    <p>
                        Настоящим, оставляя свои персональные данные на сайте vin-kode.ru (и его поддомены) (далее —
                        Сайт), я, действуя свободно, своей волей и в своем интересе, подтверждаю свое согласие на
                        обработку моих персональных данных в соответствии с Федеральным законом Российской Федерации от
                        27.07.2006 № 152-ФЗ «О персональных данных».
                    </p>

                    <h3><strong>1. Перечень персональных данных</strong></h3>
                    <p>
                        Я даю согласие на обработку следующих персональных данных, которые могут быть предоставлены мной
                        через формы на Сайте, включая, но не ограничиваясь:
                    </p>
                    <ul>
                        <li>имя;</li>
                        <li>номер телефона;</li>
                        <li>адрес электронной почты;</li>
                        <li>иные данные, указанные мной добровольно при использовании Сайта.</li>
                    </ul>

                    <h3><strong>2. Цели обработки персональных данных</strong></h3>
                    <p>Обработка персональных данных осуществляется в целях:</p>
                    <ul>
                        <li>обработки запросов, заявок и обращений;</li>
                        <li>предоставления услуг и информации;</li>
                        <li>осуществления обратной связи;</li>
                        <li>исполнения договорных обязательств;</li>
                        <li>направления информационных и рекламных сообщений;</li>
                        <li>улучшения качества работы Сайта.</li>
                    </ul>

                    <h3><strong>3. Действия с персональными данными</strong></h3>
                    <p>Я даю согласие на совершение следующих действий с моими персональными данными:</p>
                    <p>
                        сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение),
                        использование, передача (в случаях, предусмотренных законодательством РФ), обезличивание,
                        блокирование, удаление и уничтожение.
                    </p>

                    <h3><strong>4. Срок действия согласия</strong></h3>
                    <p>
                        Настоящее согласие действует с момента его предоставления и до момента его отзыва Пользователем.
                    </p>

                    <h3><strong>5. Отзыв согласия</strong></h3>
                    <p>
                        Я уведомлен(а), что согласие на обработку персональных данных может быть отозвано мной в любой
                        момент путем направления письменного уведомления Администрации Сайта на электронную почту,
                        указанную в разделе «Помощь» на Сайте.
                    </p>

                    <h3><strong>6. Заключительные положения</strong></h3>
                    <p>
                        Я подтверждаю, что ознакомлен(а) с Политикой конфиденциальности сайта vin-kode.ru (и его
                        поддомены), понимаю свои права и обязанности в области обработки персональных данных и
                        подтверждаю достоверность предоставленных мною данных.
                    </p>
                </n-text>
            </n-space>
        </n-scrollbar>
        <template #footer>
            <n-button type="primary" @click="showPrivacyPolicyModal = false"> Закрыть </n-button>
        </template>
    </n-modal>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import { signUp } from "@/backend.api";
import identityResult from "@/models/identityResult";
import {
    useMessage,
    NInput,
    NInputGroup,
    NInputGroupLabel,
    NFormItem,
    NButton,
    NResult,
    NForm,
    NCheckbox,
    NText,
    NModal,
    NScrollbar,
    NSpace,
    FormItemRule
} from "naive-ui";

const formRef = ref(null) as any;
const message = useMessage();
let isLoading = ref(false);
let isFinished = ref(false);
let showPrivacyPolicyModal = ref(false);

const size = ref("medium");

const formValue = ref({
    name: "",
    phone: "",
    email: "",
    city: "",
    agreementAccepted: false
});

const rules = {
    name: {
        required: true,
        message: "Обязательно",
        trigger: ["input"]
    },
    email: {
        required: true,
        message: "Обязательно",
        trigger: ["input"],
        type: "email"
    },
    phone: {
        required: true,
        message: "Обязательно",
        trigger: ["input"],
        validator: (_rule: FormItemRule, value: string) => {
            return /^\d{10,12}$/.test(value);
        }
    },
    city: {
        required: true,
        message: "Обязательно",
        trigger: ["input"],
        type: "text",
        validator: (_rule: FormItemRule, value: string) => {
            return value.length > 0;
        }
    },
    agreementAccepted: {
        required: true,
        message: "Необходимо дать согласие",
        trigger: ["change"],
        validator: (_rule: FormItemRule, value: boolean) => {
            return value === true;
        }
    }
};

const showPrivacyPolicy = () => {
    showPrivacyPolicyModal.value = true;
};

const handleSubmitButton = (e: any) => {
    e.preventDefault();
    formRef.value?.validate(async (errors: any) => {
        if (!errors) {
            isLoading.value = true;
            debugger;
            const promise = signUp(formRef.value.model);
            promise
                .then((response) => {
                    const result = new identityResult(response.data);
                    if (result.succeeded) {
                        isFinished.value = true;
                    } else {
                        result.getDescriptions();
                        message.error(result.getDescriptions());
                    }
                })
                .finally(() => {
                    isLoading.value = false;
                });
        }
    });
};
</script>

<style scoped>
.main {
    display: grid;
    place-items: center;
    justify-content: center;
}
</style>
